<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @edit-account="editAccount"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('tbale_header_appAccount') || '应用账号' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled" />
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="editAccount({ type: 'add' })"
            >
              {{ $l('btn_addAccount') || '添加账号' }}
            </b-button>
          </div>
        </div>
      </template>
    </PageMain>

    <AccountEdit
      :visible.sync="accountEditOpts.visible"
      :type="accountEditOpts.type"
      :amzAppCode="amzAppCode"
      :amzAppAccountCode="accountEditOpts.amzAppAccountCode"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import AccountEdit from '../account-edit'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, AccountEdit },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzAppCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      accountEditOpts: { visible: false, type: '', amzAppAccountCode: '' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzAppCode) return
      this.loading = true
      const params = { amzAppCode: this.amzAppCode }
      const res = await this.$api
        .ecomAmzAppAccountListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    editAccount({ type, data: { amzAppAccountCode = '' } = {} }) {
      this.accountEditOpts = { visible: true, type, amzAppAccountCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
